import { useContext, useEffect } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import { autop } from '@wordpress/autop';

import PageContext from '@contexts/PageContext';
import { getLanguageId } from '@helpers/language';
import { getBackupImg } from '@helpers/dataExists';
import { Container, Button, CheckboxInput } from '@components';
import { checkEnabled, checkValue } from '@components/OptionalFeature';
import styles from './BodyFullContent.module.scss';

const DynamicImage = dynamic(() => import('@components/DynamicImage'), { ssr: false });

const BodyFullContent = ({ data, pageId, componentIsAvailable, showTitle, componentTitle }) => {
  const router = useRouter();
  const { locale } = router;
  const pageData = useContext(PageContext);
  const { PostText, PostTextSection, DisplayOptions } = pageData;

  const filteredPostTextSection = PostTextSection?.filter((post) => parseInt(post.LanguageId) === getLanguageId(locale));

  // check button target is Enable
  const buttonTargetAvailable = checkEnabled(data?.DisplayOptions, 'ButtonTarget');

  // check button text is Enabled
  const buttonTextAvailable = checkEnabled(data?.DisplayOptions, 'ButtonText');

  // check button url is enabled
  const buttonURLAvailable = checkEnabled(data?.DisplayOptions, 'ButtonURL');

  // check has image
  const hasImage = checkEnabled(data?.DisplayOptions, 'HasImage');

  // check Title is enabled
  const titleIsAvailable = checkEnabled(data?.DisplayOptions, 'Title');

  // check SectionBody is Enabled
  const sectionBodyAvailable = checkEnabled(data?.DisplayOptions, 'SectionBody');

  useEffect(async () => {
    await getBackupImg();
  });

  return (
    componentIsAvailable &&
    PostTextSection.length > 0 ? (
      <section className={pageId === 27 ? styles.Left : styles.Section}>
        <Container className={styles.Container}>
          {showTitle && <h2 className={styles.Title}>{componentTitle}</h2>}
          {filteredPostTextSection.map((post, index) => (
            <div className={styles.BoxBorder} key={index}>
              {post.HasImage ? (
                <DynamicImage
                  imgSrc={`/api/static/media/byFile/PostTextSections/${post.Id}/PostTextSection/1_N_N_N_I_640x360.jpg`}
                  sizes={'640x360'}
                  alt={post.Title}
                  className={styles.Image}
                />
              ) : null}
              {titleIsAvailable && <h2 className={styles.Title}>{post.Title}</h2>}
              {sectionBodyAvailable && post.SectionBody && (
                <div
                  className={styles.Table}
                  dangerouslySetInnerHTML={{ __html: autop(post.SectionBody) }}
                />
              )}
              {buttonTextAvailable && post.ButtonText != null && post.ButtonText != '' && (
                <Button
                  animated
                  className={styles.Button}
                  href={buttonURLAvailable ? post.ButtonUrl : null}
                  target={buttonTargetAvailable ? post.ButtonTarget : null}
                >
                  {post.ButtonText}
                </Button>
              )}
            </div>
          ))}
        </Container>
      </section>
    ) : null
  );
};

export default BodyFullContent;
